import { CultureInfo } from '../culture-info.model';
import { CultureInfoEn } from './en';

/**
 * @ignore
 */
export const CultureInfoEnUS: CultureInfo = {
  name: 'en-US',
  displayName: 'English (United States)',
  iso3LanguageCode: 'eng',
  iso2LanguageCode: 'en',
  ietfLanguageTag: 'en-US',
  parent: CultureInfoEn
};
